module.exports = __webpack_public_path__ + "static/purchaseSuccess-750e6adcdc8cc4d7a291b7fe3b70061b.mp3";